import {useEffect, useRef} from 'react';
import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {useChekinSDK} from 'context/ChekinSDK';
import {useErrorToast} from 'hooks';
import {API, GuestTokenStorageHandler} from '@chekin/api';
import {useAnalytics} from 'analytics';
import {POSTHOG_EVENTS} from 'analytics/posthog';

function useFetchParticipants() {
  const {isSuccessSDK} = useChekinSDK();
  const {track} = useAnalytics();

  const queryData = useQuery({
    queryKey: [QUERY_CACHE_KEYS.participants],
    queryFn: () => API.auth.getParticipants(),
    enabled: isSuccessSDK && Boolean(GuestTokenStorageHandler.getToken()),
  });
  useErrorToast(queryData.error);

  const hasTrackedErrorRef = useRef(false);
  useEffect(() => {
    if (queryData.error && !hasTrackedErrorRef.current) {
      hasTrackedErrorRef.current = true;
      track(POSTHOG_EVENTS.INSTANT_CHECK_IN_FAILED, {
        failure_reason: 'participants_load_error',
        status_code: (queryData.error as {status_code?: number})?.status_code,
      });
    } else if (!queryData.error) {
      hasTrackedErrorRef.current = false;
    }
  }, [queryData.error, track]);

  return queryData;
}

export {useFetchParticipants};
